import { render } from "./ActiveStrategies.vue?vue&type=template&id=25f3b075&scoped=true"
import script from "./ActiveStrategies.vue?vue&type=script&lang=js"
export * from "./ActiveStrategies.vue?vue&type=script&lang=js"

import "./ActiveStrategies.vue?vue&type=style&index=0&id=25f3b075&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-25f3b075"]])

export default __exports__